/**
 * Css transform property variants
 */
export const transforms = {
  translateX: translate('X'),
  translateY: translate('Y'),
  rotate: (props: TransformProps) => `
    transform: rotate(${props.rotate}deg)
  `,
  scale: (props: TransformProps) => `
    transform: rotate(${props.scale})
  `,
  scaleX: translate('X'),
  scaleY: translate('Y'),
  transform: (props: TransformProps) => `
    ${props && props.transform && `transform:${props.transform}`};
  `,
  transformOrigin: (props: TransformProps) => `
    ${props && props.transform && `transform-origin: ${props.transformOrigin}`};
  `,
};

/**
 * Performs a CSS translation by X axis
 *
 * @param axis - Indicates the axis on which to apply the transform
 */
function translate(axis: 'X' | 'Y') {
  return function translateByAxis(props: TransformProps) {
    return `transform: translate${axis}(${props.translateX});`;
  };
}
export interface TransformProps {
  /** Variant for css translateX property */
  translateX?: string;
  /** Variant for css translateY property */
  translateY?: string;
  /** Variant for css rotate property */
  rotate?: number;
  /** Variant for css scale property */
  scale?: string;
  /** Variant for css scaleX property */
  scaleX?: string;
  /** Variant for css scaleY property */
  scaleY?: string;
  /** Variant for css combined transform properties */
  transform?: string;
  /** Variant for css transform origin property */
  transformOrigin?: string;
}
